import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { clearUpdateCampaign } from '../../../modules/actions/campaigns'
import { campaignUpdateErrorSelector, campaignWasUpdatedSelector } from '../../../modules/selectors/campaigns'

const useCampaignClearEffects = () => {
  const dispatch = useDispatch()

  const campaignUpdateWasUpdated = useSelector(campaignWasUpdatedSelector)
  const campaignUpdateError = useSelector(campaignUpdateErrorSelector)

  useEffect(() => {
    if (campaignUpdateWasUpdated || campaignUpdateError) {
      dispatch(clearUpdateCampaign())
    }
  }, [dispatch, campaignUpdateWasUpdated, campaignUpdateError])
}

export default useCampaignClearEffects
